export const deepOmit = <T extends Record<string, any>>(
  keyToRemove: string,
  obj: T,
): T => {
  if (typeof obj !== 'object' || obj === null) {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map((item) => deepOmit(keyToRemove, item)) as unknown as T;
  }

  const newObj = {} as T;
  for (const key in obj) {
    if (key !== keyToRemove) {
      newObj[key] = deepOmit(keyToRemove, obj[key]);
    }
  }

  return newObj;
};
